module.exports = __webpack_public_path__ + "img/postcard_back.6c848324.jpeg";